var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 600,
    height: 480,
    viewBox: "0 0 600 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01_wallet_illustration 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.18,
    d: "M148 150H472C487.464 150 500 162.536 500 178V352C500 367.464 487.464 380 472 380H148C132.536 380 120 367.464 120 352V178C120 162.536 132.536 150 148 150Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.18,
    d: "M120 178C120 159.333 129.333 150 148 150H420C453.333 150 470 166.667 470 200V230C470 243.333 463.333 250 450 250H260C246.667 250 240 243.333 240 230V200C240 185.333 233.333 178 220 178H120Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.18,
    d: "M150 320H470",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.18,
    d: "M168 270H332C336.418 270 340 273.582 340 278V298C340 302.418 336.418 306 332 306H168C163.582 306 160 302.418 160 298V278C160 273.582 163.582 270 168 270Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.18,
    d: "M464 265C464 272.732 457.732 279 450 279C442.268 279 436 272.732 436 265C436 257.268 442.268 251 450 251C457.732 251 464 257.268 464 265Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.18,
    d: "M456 265C456 268.314 453.314 271 450 271C446.686 271 444 268.314 444 265C444 261.686 446.686 259 450 259C453.314 259 456 261.686 456 265Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.18,
    d: "M194 120C194 138.778 178.778 154 160 154C141.222 154 126 138.778 126 120C126 101.222 141.222 86 160 86C178.778 86 194 101.222 194 120Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.18,
    d: "M182 120C182 132.15 172.15 142 160 142C147.85 142 138 132.15 138 120C138 107.85 147.85 98 160 98C172.15 98 182 107.85 182 120Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.18,
    d: "M152 120H168M160 112V128",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.18,
    d: "M247 92C247 104.15 237.15 114 225 114C212.85 114 203 104.15 203 92C203 79.8497 212.85 70 225 70C237.15 70 247 79.8497 247 92Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.18,
    d: "M238 92C238 99.1797 232.18 105 225 105C217.82 105 212 99.1797 212 92C212 84.8203 217.82 79 225 79C232.18 79 238 84.8203 238 92Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.18,
    d: "M205 70C195 50 180 43.3333 160 50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.18,
    d: "M90 410H530",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#032211"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletDesktop);
export default __webpack_public_path__ + "static/media/wallet-desktop.22248838ac45ee6aa84d8828055b97c6.svg";
export { ForwardRef as ReactComponent };